(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function activeMainMedia(gallery) {
    return gallery.querySelector('[id^="Slider-Gallery"] .product__media-item.is-active .product-media-container')
      || gallery.querySelector('[id^="Slider-Gallery"] .product__media-item.is-active .media')
      || gallery.querySelector('[id^="Slider-Gallery"] .product__media-item .product-media-container')
      || gallery.querySelector('[id^="Slider-Gallery"] .product__media-item .media');
  }

  function itemStep(list) {
    var first = list.querySelector('li');
    if (!first) return 100;
    var rect = first.getBoundingClientRect();
    var styles = window.getComputedStyle(list);
    var gap = parseFloat(styles.rowGap || styles.gap || '0') || 0;
    return rect.height + gap;
  }

  function updateButtons(thumbnails, list) {
    if (!isDesktop()) return;
    var prev = thumbnails.querySelector('button[name="previous"]');
    var next = thumbnails.querySelector('button[name="next"]');
    var maxScroll = Math.max(0, list.scrollHeight - list.clientHeight);
    if (prev) prev.toggleAttribute('disabled', list.scrollTop <= 1);
    if (next) next.toggleAttribute('disabled', list.scrollTop >= maxScroll - 1);
  }

  function syncGallery(gallery) {
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    var list = gallery.querySelector('[id^="Slider-Thumbnails"]');
    var media = activeMainMedia(gallery);
    if (!thumbnails || !list || !media) return;

    if (!isDesktop()) {
      gallery.style.removeProperty('--thumbnail-rail-height');
      thumbnails.style.removeProperty('height');
      return;
    }

    var mediaHeight = Math.round(media.getBoundingClientRect().height);
    if (!mediaHeight || mediaHeight < 240) return;

    var prev = thumbnails.querySelector('button[name="previous"]');
    var next = thumbnails.querySelector('button[name="next"]');
    gallery.style.setProperty('--thumbnail-rail-height', mediaHeight + 'px');
    thumbnails.style.height = mediaHeight + 'px';
    updateButtons(thumbnails, list);
  }

  function enhanceGallery(gallery) {
    if (gallery.dataset.verticalThumbsEnhanced === 'true') return;
    gallery.dataset.verticalThumbsEnhanced = 'true';

    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    var list = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (!thumbnails || !list) return;

    thumbnails.querySelectorAll('button[name="previous"], button[name="next"]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (!isDesktop()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var direction = button.name === 'next' ? 1 : -1;
        var step = Number(button.dataset.step || 3);
        list.scrollBy({ top: direction * step * itemStep(list), behavior: 'smooth' });
        window.setTimeout(function () { updateButtons(thumbnails, list); }, 180);
      }, true);
    });

    list.addEventListener('scroll', function () {
      if (isDesktop()) updateButtons(thumbnails, list);
    }, { passive: true });

    var scheduleSync = function () {
      window.requestAnimationFrame(function () { syncGallery(gallery); });
    };

    gallery.addEventListener('click', function (event) {
      if (event.target.closest('[id^="Slider-Thumbnails"] button')) {
        window.setTimeout(scheduleSync, 80);
      }
    });

    gallery.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) image.addEventListener('load', scheduleSync, { once: true });
    });

    new MutationObserver(scheduleSync).observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-current']
    });

    window.addEventListener('resize', scheduleSync, { passive: true });
    scheduleSync();
    window.setTimeout(scheduleSync, 300);
    window.setTimeout(scheduleSync, 1000);
  }

  ready(function () {
    document.querySelectorAll('media-gallery').forEach(enhanceGallery);
  });
})();
